import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { TypePoiRequestDto, TypePoiResponseDto } from './type-poi.model';

@Injectable({
  providedIn: 'root'
})
export class TypePoiStateService {

    private typePoisSubject: BehaviorSubject<TypePoiResponseDto[]> = new BehaviorSubject<TypePoiResponseDto[]>([]);
    private typePoi: BehaviorSubject<TypePoiRequestDto> = new BehaviorSubject<TypePoiRequestDto>(new TypePoiRequestDto('','',''));

    setTypePois(typePois: TypePoiResponseDto[]): void {
        this.typePoisSubject.next(typePois);
    }

    getTypePois(): Observable<TypePoiResponseDto[]> {
        return this.typePoisSubject.asObservable()
    }

    getCurrentTypePois(){
        return this.typePoisSubject.getValue();
    }

    addTypePoi(newTypePoi: TypePoiResponseDto): void {
        const currentTypePois = this.typePoisSubject.value;
        this.typePoisSubject.next([...currentTypePois, newTypePoi]);
    }

    updateTypePoi(updatedTypePoi: TypePoiResponseDto): void {
        const currentTypePois = this.typePoisSubject.value;
        const index = currentTypePois.findIndex(t => t.id === updatedTypePoi.id);
        if (index > -1) {
            currentTypePois[index] = updatedTypePoi;
            this.typePoisSubject.next([...currentTypePois]);
        }
    }

    deleteTypePoi(id: number): void {
        const currentTypePois = this.typePoisSubject.value;
        this.typePoisSubject.next(currentTypePois.filter(t => t.id !== id));
    }

    setTypePoi(typePois: TypePoiRequestDto): void {
        this.typePoi.next(typePois);
    }

    getTypePoi(): Observable<TypePoiRequestDto> {
        return this.typePoi.asObservable()
    }

}
